import { Box, Paper, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'

type TipsCardProps = {
  title: string
  tips: string[]
}

/** Sidebar guidance card with a lightbulb header and bulleted tips. */
export default function TipsCard({ title, tips }: TipsCardProps) {
  const theme = useTheme()
  const c = theme.affexy.colors

  return (
    <Paper
      variant="outlined"
      sx={{ p: 2.25, borderRadius: `${theme.affexy.radii.md}px`, borderColor: 'divider', display: 'flex', flexDirection: 'column', gap: 1.25 }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <LightbulbOutlinedIcon sx={{ fontSize: 15, color: c.warning }} />
        <Typography variant="overline" sx={{ fontSize: 11, color: c.ink48 }}>
          {title}
        </Typography>
      </Box>
      <Box component="ul" sx={{ m: 0, pl: 2, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        {tips.map((tip) => (
          <Typography key={tip} component="li" sx={{ fontSize: 13, color: c.ink72, lineHeight: 1.5 }}>
            {tip}
          </Typography>
        ))}
      </Box>
    </Paper>
  )
}
